<div class="p-mb-3 p-fluid" *ngIf="showMessage">
  <p-messages severity="warn">
    <ng-template pTemplate>
      <div class="p-d-flex p-jc-between" style="width: 100%">
        <div class="p-d-flex p-flex-column gap-6">
          <div *ngFor="let msg of messages">{{ msg }}</div>
        </div>
        <div class="p-d-flex p-ai-center p-jc-center">
          <span
            class="p-message-icon pi pi-exclamation-triangle"
            style="font-size: 4rem"
          ></span>
        </div>
      </div>
    </ng-template>
  </p-messages>
</div>

<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="izvodiTable"
    [chipItems]="chipItems"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
